<div class="register-container">
    <!--Banner starts here-->
    <section id="banner" class="banner">
      <div class="container">
        <div class="banner__logos">
          <div>
            <img
              src="../../assets/images/ust_logowhite.png"
              class="banner__logosz"
              alt="ust-logo"
            />
          </div>
        </div>
        <div class="banner__main">
          <div class="banner__mainlabel">Sign Up</div>
          <form name="form" (ngSubmit)="f.form.valid && register(f)" #f="ngForm" novalidate>
            <div class="row" style="margin-bottom: 20px">
                <div class="col-md-12 col-lg-12 col-sm-12">
                  <div class="input-group">
                    <span class="input-group-addon" 
                    id="sizing-addon2"><img src="assets/images/user.png" 
                    style="width: 18px;"></span>
                    <input
                      type="text"
                      class="form-control banner__iputpad"
                      id="username"
                      name="username"
                      [(ngModel)]="form.username"
                      required
                      placeholder="Username" maxlength="50"
                    />
                  </div>
                </div>
              </div>
            <div class="row" style="margin-bottom: 20px">
              <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="input-group">
                  <span class="input-group-addon" 
                  id="sizing-addon2"><img src="assets/images/mail_new.png" 
                  style="width: 18px;"></span>
                  <input
                    type="text"
                    class="form-control banner__iputpad"
                    name="email"
                    [(ngModel)]="form.email"
                    required
                    placeholder="Email"
                  />
                </div>
              </div>
              </div>
            <div class="row" style="margin-bottom: 20px">
              <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="input-group">
                  <span class="input-group-addon" 
                  id="sizing-addon2"><img src="assets/images/padlock.png" 
                  style="width: 18px;"></span>
                  <input
                    type="password"
                    class="form-control banner__iputpad"
                    id="password"
                    name="password"
                    [(ngModel)]="form.password"
                    required
                    placeholder="Password"
                  />
                </div>
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px">
              <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="input-group">
                  <span class="input-group-addon" 
                  id="sizing-addon2"><img src="assets/images/padlock.png" 
                  style="width: 18px;"></span>
                  <input
                    type="password"
                    class="form-control banner__iputpad"
                    id="confirmpassword"
                    name="confirmpassword"
                    required
                    placeholder="Confirm Password"
                    [(ngModel)]="form.confirmpassword"
                  />
                </div>
              </div>
            </div>
            <div class="banner__check">
              <div class="form-check">
                <label class="form-check-label" for="check1">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="check1"
                    name="check1"
                    value="checked1"
                    required
                    [(ngModel)]="termCond1"
                  />I accept the practices, uses and disclosures of my personal
                  information as described in the privacy policy and notices of
                  privacy practices
                </label>
              </div>
              <div class="form-check">
                <label class="form-check-label" for="check1">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="check2"
                    name="check2"
                    value="checked2"
                    required
                    [(ngModel)]="termCond2"
                  />I consent to the collection, processing, transmitting,
                  disclosure, storage and use of my personal data submitted by me
                  for the UST application process or obtained by UST from third
                  parties as part of the process
                </label>
              </div>
            </div>
            <button
              type="submit"
              [style.opacity]="(!f.form.valid || isSavePending) ? '0.7' : '1'"
              [disabled]="(!f.form.valid || isSavePending)"
              class="banner__btncustom"
            >
              Sign Up
            </button>
          </form>
          <div class="banner__signup">
            <div>
              Already have an account?&nbsp;&nbsp;<a class="color-let" href="/login">Sign In.</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  